import { render, staticRenderFns } from "./ProjectCard.vue?vue&type=template&id=d729cdb6&scoped=true&"
import script from "./ProjectCard.vue?vue&type=script&lang=ts&"
export * from "./ProjectCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d729cdb6",
  null
  
)

export default component.exports